import generateTypes from '../utils/generateTypes';

export const GET_DATA_IMPORTS = generateTypes('GET_DATA_IMPORTS');
export const RESET_DATA_IMPORTS = generateTypes('RESET_DATA_IMPORTS');
